import { Result, Button } from 'antd';
import { history } from 'umi';

const Index: React.FC = () => {
  return <Result
    status="404"
    title="404"
    style={{ width: '100%', height: '100%' }}
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        Back Home
      </Button>
    }
  />
}

export default Index;
